var store = {
	namespaced: true,
	state: {
		ui: {
			pageTitles: false,
			listCollapse: false,
			listSortEnabled: false,
			toggleOption: "default", // can be default, open, close
			backgroundImage: 'none' // can be fireblossom, or none
		},
		widget: {
			noUnderlines: false,
		},
	},
	getters: {
		ui: function (state) {
			return state.ui;
		},
		hasBackground : function(state) {
			if(state.ui && state.ui.backgroundImage && state.ui.backgroundImage !== 'none') {
				return state.ui.backgroundImage;
			} else {
				return null;
			}
		},
		widget: function (state) {
			return state.widget;
		},
	},
	mutations: {
		SET_UI_STATE: function (state, obj) {
			if (obj && obj.ui) {
				state.ui = obj.ui;
			}
		},
		SET_WIDGET_STATE: function (state, obj) {
			if (obj && obj.widget) {
				state.widget = obj.widget;
			}
		},
		SET_SETTINGS: function (state, obj) {
			state.widget = obj.widget;
			state.ui = obj.ui;
		},
	},
	actions: {
		getUiState: function (context) {
			return new Promise((resolve) => {
				context
					.dispatch("cache/get", "settingsState", { root: true })
					.then((data) => {
						if (data.settingsState) {
							context.commit("SET_SETTINGS", data.settingsState);
						}
					});
			});
		},
		saveUiState: function (context, ui) {
			let obj = {
				ui: ui,
			};
			return new Promise((resolve, reject) => {
				context.dispatch(
					"cache/save",
					{
						key: "settingsState",
						value: context.state,
					},
					{ root: true }
				);
				context.commit("SET_UI_STATE", obj);
			});
		},
	},
};

export default store;
